<template>
  <div />
</template>

<script>
import moment from 'moment'
import auth from '@/composables/auth'
import apiReferensi from '@/composables/referensi'
import hakAkses from '@/utils/hakAkses'

export default {
  created() {
    this.$cookies.remove('token')
    this.$cookies.remove('username')
    this.$cookies.remove('tahun')
    this.$cookies.remove('roles_b')
    this.$cookies.remove('kolok')
    this.$cookies.remove('nalok')
    this.$cookies.remove('jenisAkun')
    this.$cookies.remove('wilayah')
    this.$cookies.remove('filterWilayahPerkin')
    this.$cookies.remove('kib')
    this.$cookies.remove('listTahun')

    const username = this.$route.query.username ?? null
    const token = this.$route.query.token ?? null
    const tahun = this.$route.query.tahun ?? null
    const kib = this.$route.query.kib ?? 'B'
    this.$cookies.set('token', token)
    this.$cookies.set('username', username)
    this.$cookies.set('tahun', tahun)

    const getTahunSensus = kib => apiReferensi.getTahunSensus(this, { kib })

    const getData = async () => {
      const params = {
        username,
        tahun: moment().format('YYYY'),
      }
      const resUserData = await auth.getUserData(this, params)

      let roles_b = ''
      let kolok = ''
      let nalok = ''
      let jenisAkun = ''
      let wilayah = ''

      if (resUserData.data) {
        console.log(resUserData.data)
        roles_b = resUserData.data.roles_b
        kolok = resUserData.data.kolok
        nalok = resUserData.data.nalok
        jenisAkun = resUserData.data.jenis_akun
        wilayah = resUserData.data.id_wilayah
        if (roles_b == 'pua-admin') {
          jenisAkun = 'admin'
        } else if (resUserData.data.roles_b == 'Admin-ViewOnly') {
          jenisAkun = 'internal'
        } else if (resUserData.data.roles_b == 'External') {
          jenisAkun = 'external'
        }
      } else if (resUserData.messsage == 'User Merupakan Admin') jenisAkun = 'Super Admin'
      console.log(jenisAkun)

      let filterWilayahPerkin = []

      if (jenisAkun == 'Super Admin') {
        filterWilayahPerkin = [0, 1, 2, 3, 4, 5, 6]
      } else if (jenisAkun == 'pelaksana-suban') {
        kolok = ''
        nalok = ''
      } else if (jenisAkun == 'internal') {
        if (username == 124658) filterWilayahPerkin = [0, 1]
        else if (username == 202600) filterWilayahPerkin = [4, 6]
        else if (username == 113810) filterWilayahPerkin = [2, 3]
        else if (username == 202462) filterWilayahPerkin = [5]
      }

      if (!hakAkses[jenisAkun]) {
        this.$cookies.set('username', '')
        this.$router.push({ name: 'login' })
      } else {
        const userData = {
          ability: hakAkses[jenisAkun],
        }

        localStorage.setItem('userData', JSON.stringify(userData))
        this.$ability.update(userData.ability)

        this.$cookies.set('roles_b', roles_b)
        this.$cookies.set('kolok', kolok)
        this.$cookies.set('nalok', nalok)
        this.$cookies.set('jenisAkun', jenisAkun)
        this.$cookies.set('wilayah', wilayah)
        this.$cookies.set(
          'filterWilayahPerkin',
          JSON.stringify(filterWilayahPerkin),
        )
        this.$cookies.set(
          'kib',
          kib,
        )

        const result = await getTahunSensus(kib)
        this.$cookies.set('listTahun', JSON.stringify(result.rows))
        const kiblowercase = kib.toLowerCase()
        if (process.env.VUE_APP_ENV == 'development') {
          if (jenisAkun == 'external') {
            window.location.href = `/${kiblowercase}/daftar-bmd` 
          } else {
            window.location.href = `/${kiblowercase}`
          }
        }
        else if (process.env.VUE_APP_ENV == 'staging') {
          if (jenisAkun == 'external') {
            window.location.href = `/inventarisasi/st/${kiblowercase}/daftar-bmd`
          } else {
            window.location.href = `/inventarisasi/st/${kiblowercase}`
          }
        }
        else {
          if (jenisAkun == 'external') {
            window.location.href = `/inventarisasi/pr/${kiblowercase}/daftar-bmd`
          } else {
            window.location.href = `/inventarisasi/pr/${kiblowercase}`
          }
        }
      }
      // this.$router.push({ name: 'cDashboard' })
    }
    getData()
  },
}
</script>
